// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_kd-0";
export var discountCodeInput = "_kd-1";